module.exports = __webpack_public_path__ + "img/z (17).6e35bae7.png";